<app-type-cr-jugement id="step9" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[criteres]="initial.criteres"></app-type-cr-jugement>


